import { FETCH_PRODUCT_MAX_QUANTITY_USERS, SELECT_EDIT_PURCHASE_LIMIT_USER } from '../actions/types'

const initialState = {
  selectedUser: null,
  productMaxQuantitiesUsers: {}
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SELECT_EDIT_PURCHASE_LIMIT_USER:
      return { ...state, selectedUser: action.payload }
    case FETCH_PRODUCT_MAX_QUANTITY_USERS:
      return {
        ...state,
        productMaxQuantitiesUsers: {
          ...state.productMaxQuantitiesUsers,
          [action.payload.productId]: action.payload
        }
      }
    default:
      return state
  }
}
